<template>
  <div class="image-upload">
    <v-file-input
      show-size
      outlined
      :label="label"
      required
      :accept="acceptedImages"
      :value="value"
      @change="onChange"
      prepend-inner-icon="mdi-camera"
      :prepend-icon="null"
      :clearable="clearable"
      :error-messages="errorMessages"
      @click:clear="removeImage"
    ></v-file-input>

    <v-img
      v-if="previewUrl && !isSvg"
      :max-height="maxHeight"
      :aspect-ratio="1.5"
      contain
      class="grey lighten-3 rounded mb-6"
      :src="previewUrl"
      :lazy-src="previewUrl"
    />

    <inline-svg
      v-else-if="previewUrl && isSvg"
      :src="previewUrl"
    />

  </div>
</template>
<script>
import get from 'lodash/get'
import InlineSvg from 'vue-inline-svg'

export default {
  props: {
    label: {
      type: String,
      default: 'Image'
    },
    clearable: {
      type: Boolean,
      default: false
    },
    value: {
      type: [String, Object, File],
      default () {
        return null
      }
    },
    errorMessages: {
      type: [String, Array],
      default () {
        return null
      }
    },
    maxHeight: {
      type: String,
      default: '480'
    },
    acceptedImages: {
      type: String,
      default: '.jpg, .jpeg, .png, .svg'
    }
  },

  components: {
    InlineSvg
  },
  computed: {
    previewUrl () {
      if (this.value instanceof File) {
        return URL.createObjectURL(new File([this.value], this.value.name))
      }

      if (this.value instanceof Object) {
        return get(this.value, 'url')
      }

      return null
    },

    isSvg () {
      if (this.value instanceof File && this.value.type === 'image/svg+xml') {
        return true
      }
      return false
    }
  },
  methods: {
    onChange (file) {
      this.$emit('input', file)
      this.$emit('update:updateThumbnail', true)
    },

    removeImage () {
      if (this.value.id) {
        this.$emit('update:removeImage', true)
      } else {
        this.$emit('update:removeImage', false)
      }
    }
  }
}
</script>
